import branding from "./branding";

function Dashboard({
  language,
  userEmail,
  onStartTutor,
  onLogout,
  results,
  weakTopics,
}) {

  const totalScorePercentage =
    results && results.length > 0
      ? Math.round(
        results.reduce(
          (total, result) =>
            total + Number(result.percentage || 0),
          0
        ) / results.length
      )
      : 0;

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f3f6fb",
        padding: "40px",
      }}
    >

      <div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            marginBottom: "12px",
          }}
        >
          <img
            src="/ScienceTutor.png"
            alt="Science Tutor logo"
            style={{
              width: "150px",
              maxWidth: "40%",
              height: "auto",
              display: "block",
            }}
          />

          <h1
            style={{
              color: branding.primaryColor,
              margin: "0",
              textAlign: "left",
            }}
          >
            {branding.appName}
          </h1>
        </div>


        <button
          type="button"
          onClick={onLogout}
          style={{
            background: "transparent",
            color: branding.primaryColor,
            border: `2px solid ${branding.primaryColor}`,
            padding: "9px 14px",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          {language === "af" ? "Teken uit" : "Logout"}
        </button>
      </div>


      <p>
        {language === "af" ? "Welkom terug" : "Welcome back"}:{" "}
        <strong>{userEmail}</strong>
      </p>

      <div
        style={{
          display: "flex",
          gap: "20px",
          marginTop: "30px",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            background: "white",
            padding: "20px",
            borderRadius: "12px",
            width: "250px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
          }}
        >
          <h3>
            🎓 {language === "af" ? "Begin Tutor" : "Start Tutor"}
          </h3>

          <p>
            {language === "af"
              ? "Begin jou Chemie-tutorsessie."
              : "Start your Chemistry tutoring session."}
          </p>

          <button
            type="button"
            onClick={onStartTutor}
            style={{
              background: branding.primaryColor,
              color: "white",
              border: "none",
              padding: "10px 15px",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            {language === "af" ? "Begin" : "Start"}
          </button>
        </div>

        <div
          style={{
            background: "white",
            padding: "20px",
            borderRadius: "12px",
            width: "250px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
          }}
        >
          <h3>
            📊 {language === "af" ? "Resultate" : "Results"}
          </h3>

          {results && results.length > 0 ? (
            results.map((result, index) => (
              <div
                key={result.resultId || index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "12px",
                  marginBottom: "10px",
                }}
              >
                <span>
                  {language === "af" ? "Vraestel" : "Paper"} {index + 1}
                </span>

                <span
                  style={{
                    color: "#2563eb",
                    fontWeight: "bold",
                  }}
                >
                  {result.marksAwarded}/{result.marksAvailable}
                </span>
              </div>
            ))

          ) : (
            <p>
              {language === "af"
                ? "Nog geen resultate nie."
                : "No results yet."}
            </p>
          )}
        </div>

        {/* PREVIOUS PAPERS */}
        <div
          style={{
            background: "white",
            padding: "20px",
            borderRadius: "12px",
            width: "250px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
          }}
        >
          <h3>
            📚{" "}
            {language === "af"
              ? "Vorige Vraestelle"
              : "Previous Papers"}
          </h3>

          {results && results.length > 0 ? (
            results.map((result, index) => (
              <div
                key={result.resultId || index}
                style={{
                  marginBottom: "15px",
                  padding: "10px",
                  background: "#f9fafb",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  <strong>
                    {language === "af" ? "Vraestel" : "Paper"}{" "}
                    {index + 1}
                  </strong>

                  <span
                    style={{
                      color: "#2563eb",
                      fontWeight: "bold",
                    }}
                  >
                    {language === "af" ? "Punt" : "Score"}:{" "}
                    {Math.round(result.percentage)}%
                  </span>
                </div>

                <div
                  style={{
                    marginTop: "8px",
                    fontSize: "13px",
                    color: "#6b7280",
                  }}
                >
                  {result.completedAt
                    ? new Date(result.completedAt).toLocaleDateString(
                      language === "af" ? "af-ZA" : "en-ZA",
                      {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      }
                    )
                    : language === "af"
                      ? "Datum nie beskikbaar nie"
                      : "Date unavailable"}
                </div>
              </div>
            ))
          ) : (
            <p>
              {language === "af"
                ? "Nog geen vraestelle nie."
                : "No papers yet."}
            </p>
          )}
        </div>

        {/* AREAS FOR IMPROVEMENT */}
        <div
          style={{
            background: "white",
            padding: "20px",
            borderRadius: "12px",
            width: "250px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
          }}
        >
          <h3>
            🎯{" "}
            {language === "af"
              ? "Areas vir Verbetering"
              : "Areas for Improvement"}
          </h3>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "12px",
              marginBottom: "15px",
              padding: "10px",
              background: "#eff6ff",
              borderRadius: "8px",
            }}
          >
            <strong>
              {language === "af"
                ? "Algehele Prestasie"
                : "Overall Performance"}
            </strong>

            <span
              style={{
                color: "#2563eb",
                fontWeight: "bold",
                fontSize: "17px",
              }}
            >
              {totalScorePercentage}%
            </span>
          </div>

          <h4
            style={{
              marginTop: "18px",
              marginBottom: "10px",
              color: "#374151",
              borderBottom: "1px solid #e5e7eb",
              paddingBottom: "8px",
            }}
          >
            {language === "af"
              ? "Swak Onderwerpe"
              : "Weak Topics"}
          </h4>

          {weakTopics && weakTopics.length > 0 ? (
            weakTopics.map((topic, index) => (
              <div
                key={topic.weakTopicId || index}
                style={{
                  marginBottom: "12px",
                  padding: "10px",
                  background: "#f9fafb",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  <strong>{topic.topicName}</strong>

                  <span
                    style={{
                      color: "#2563eb",
                      fontWeight: "bold",
                    }}
                  >
                    {Math.round(topic.averagePercentage)}%
                  </span>
                </div>

                <div
                  style={{
                    marginTop: "6px",
                    fontSize: "13px",
                    color: "#6b7280",
                  }}
                >
                  {language === "af"
                    ? `${topic.correctAnswersCount} korrek uit ${topic.attemptsCount}`
                    : `${topic.correctAnswersCount} correct out of ${topic.attemptsCount}`}
                </div>
              </div>
            ))
          ) : (
            <p
              style={{
                color: "#6b7280",
                lineHeight: "1.6",
                marginBottom: "0",
              }}
            >
              {language === "af"
                ? "Geen swak onderwerpe is tans geïdentifiseer nie."
                : "No weak topics are currently identified."}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Dashboard;